import React from 'react'
import styles from './watchlists-toggle.module.scss'
import { Player } from 'types/global'
import AddRemovePlayerFromWatchList, {
  AddRemovePlayerFromWatchListProps,
} from './AddRemovePlayerFromWatchListBtn'
import { AddOrManagePlayerModalMode } from 'constants/modals'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import { managePlayerInWatchlists, setManageModalState } from 'actions/watchlist-actions'
import WTNSpinner from 'components/generic/WTNSpinner'

interface Props extends Omit<AddRemovePlayerFromWatchListProps, 'inWatchlist'> {
  player: Player
}

const WatchlistToggle = ({ player, ...props }: Props) => {
  const dispatch = useDispatch()
  const isProcessing = useSelector((state: AppState) =>
    player?.id ? !!state.watchlists.manageOperations[player.id] : false
  )
  const watchlistsPlayerIdsStore = useSelector((state: AppState) => state.watchlists.playerIdsStore)
  const allWatchlists = useSelector((state: AppState) => state.watchlists.watchlists)
  const destinationWatchlistIds = useSelector(
    (state: AppState) => state.watchlists.destinationWatchlistIds
  )
  const includedWatchlistsIds = watchlistsPlayerIdsStore[player.id] ?? []

  const handleAdd = () => {
    const validDestinationIds = destinationWatchlistIds.filter(id => !!allWatchlists[id])

    if (!validDestinationIds.length) {
      const myWatchlistsIds = Object.keys(allWatchlists)

      if (myWatchlistsIds.length === 1) {
        dispatch(managePlayerInWatchlists(player, { addToIds: myWatchlistsIds }))
        return
      }

      dispatch(
        setManageModalState({
          player,
          includedWatchlistsIds,
          mode: AddOrManagePlayerModalMode.ADD,
          isOpen: true,
        })
      )
    } else {
      dispatch(managePlayerInWatchlists(player, { addToIds: validDestinationIds }))
    }
  }

  const handleRemove = () => {
    if (includedWatchlistsIds.length === 1) {
      dispatch(managePlayerInWatchlists(player, { removeFromIds: includedWatchlistsIds }))
    } else {
      dispatch(
        setManageModalState({
          player,
          includedWatchlistsIds,
          mode: AddOrManagePlayerModalMode.MANAGE,
          isOpen: true,
        })
      )
    }
  }

  if (isProcessing) return <WTNSpinner width={40} hideLogo className={styles.loading} />

  return (
    <AddRemovePlayerFromWatchList
      {...props}
      inWatchlist={!!includedWatchlistsIds.length}
      onAddPlayer={handleAdd}
      onRemovePlayer={handleRemove}
    />
  )
}

export default WatchlistToggle
